/**
 * Wire-protocol constants shared between server and client for auth/credit gates.
 *
 * Adult gate:
 *   - Server: server/middleware/require-adult.ts
 *   - Client: client/src/lib/queryClient.ts + profile-completion listener
 *
 * Credits gate (CLICK-credits-02):
 *   - Server: server/middleware/credit-gate.ts
 *   - Client: queryClient dispatches CREDITS_REQUIRED_EVENT; CreditWallProvider opens the wall
 *
 * IMPORTANT: Do NOT change these string values without updating both sides simultaneously.
 */

/** JSON body `code` field returned by requireAdult middleware on 403 responses. */
export const ADULT_REQUIRED_CODE = "ADULT_REQUIRED" as const;

/** Custom window event name dispatched by queryClient when an ADULT_REQUIRED 403 is received. */
export const ADULT_REQUIRED_EVENT = "troopn:adult-required" as const;

/** JSON body `code` field returned by requireCredits middleware on 402 responses. */
export const CREDITS_REQUIRED_CODE = "CREDITS_REQUIRED" as const;

/** Custom window event name dispatched by queryClient when a CREDITS_REQUIRED 402 is received. */
export const CREDITS_REQUIRED_EVENT = "troopn:credits-required" as const;

export type CreditsRequiredDetail = {
  action?: string;
  cost?: number;
  balance?: number;
};
